import cubejs from "@cubejs-client/core";
import store from "../store";
import { get } from "lodash";
/**
 * Normalise les valeurs renvoyées par Cube Store qui sont toujours des chaînes,
 * même pour les booléens portés par des dimensions.
 * - "true" / "false" → true / false
 */
function castStringBooleans(resultSet) {
  const results = get(resultSet, "loadResponse.results", []);
  results.forEach((r) => {
    (r.data || []).forEach((row) => {
      Object.keys(row).forEach((key) => {
        const val = row[key];
        if (typeof val !== "string") return;
        const lower = val.toLowerCase();
        if (lower === "true") {
          row[key] = true;
          return;
        }
        if (lower === "false") {
          row[key] = false;
          return;
        }
      });
    });
  });
  return resultSet;
}

/**
 * Instance de cube js utilisée pour effectuer tous les appels
 */
export const cubeInstance = {
  instance: null,
  currentToken: null,

  /**
   * Execute une requête à cube js
   * @param {Object|Array} query
   * @param {Object} [options] - options supplémentaires (ex. { signal: AbortSignal })
   * @returns {Promise<Object>}
   * @throws {DOMException} AbortError si la requête a été annulée via le signal
   */
  async load(query, options = {}) {
    if (!this.instance) {
      throw new Error("");
    }

    const loadOptions = { castNumerics: true, ...options };

    try {
      const resultSet = await this.instance.load(query, loadOptions);
      return castStringBooleans(resultSet);
    } catch (err) {
      // Laisser remonter l'AbortError sans tenter de retry
      if (err && err.message === "aborted") {
        throw err;
      }

      // sometimes there is a string error which contains status code
      const err2Str = `${err}`;
      const forbidInStr =
        err2Str.toLowerCase().includes("status") &&
        (err2Str.includes("401") || err2Str.includes("403"));

      const errorMessage = get(err, "response.error", "").toLowerCase();
      const isInvalidTokenError =
        errorMessage.includes("invalid") && errorMessage.includes("token");

      // if it's not a 403, 401 error
      if (!forbidInStr && !isInvalidTokenError) {
        throw err;
      }

      await this.ensureToken();

      const retryResult = await this.instance.load(query, loadOptions);
      return castStringBooleans(retryResult);
    }
  },
  /**
   * Crée ou met à jour l'instance
   * @param {String} token
   */
  init(token) {
    this.currentToken = token;
    this.instance = cubejs(token, {
      apiUrl: window.VUE_APP_CUBEJS_URL + process.env.VUE_APP_CUBEJS_PREFIX_URL,
    });
  },

  /**
   * Met à jour le token
   */
  async ensureToken() {
    await store.dispatch("authentication/ensureToken");

    const accessToken = store.getters["authentication/getAccessToken"];

    this.init(accessToken);
  },
};
